var map = {
	"./pages/language-root.vue": [
		"3441",
		"chunk-2d0b9994"
	],
	"./pages/news-article.vue": [
		"d462",
		"chunk-0bfc17da",
		"chunk-0baa96e9",
		"chunk-54daf423"
	],
	"./pages/news-list.vue": [
		"7915",
		"chunk-0bfc17da",
		"chunk-0910fcd6"
	],
	"./pages/news-main.vue": [
		"7b1e",
		"chunk-0bfc17da",
		"chunk-726e00d0"
	],
	"./pages/news-sample.vue": [
		"d990",
		"chunk-7b326c56"
	],
	"./pages/parallax-test.vue": [
		"c1d8",
		"chunk-0bfc17da",
		"chunk-7a0d3e83"
	],
	"./pages/play-list.vue": [
		"f663",
		"chunk-0bfc17da",
		"chunk-0baa96e9",
		"chunk-26bc9aef"
	],
	"./pages/play-main.vue": [
		"f169",
		"chunk-0bfc17da",
		"chunk-0baa96e9",
		"chunk-dd48143a"
	],
	"./pages/play-novel.vue": [
		"3bc3",
		"chunk-4aa0c59e"
	],
	"./pages/play-viewer.vue": [
		"48cd",
		"chunk-0baa96e9",
		"chunk-3f5f1c33"
	],
	"./pages/policy-EN.vue": [
		"d059",
		"chunk-218dd35e"
	],
	"./pages/policy-JP.vue": [
		"dfe0",
		"chunk-991c6c30"
	],
	"./pages/policy-KR.vue": [
		"1542",
		"chunk-d10f00fe"
	],
	"./pages/policy.vue": [
		"1dc7",
		"chunk-0f3f4b34"
	],
	"./pages/search.vue": [
		"3685",
		"chunk-0baa96e9",
		"chunk-e66a0286"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "87e4";
module.exports = webpackAsyncContext;